import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { Motion } from '#pplx/frontend/aether/components/Motion/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { useAskInputSourceLimitWarning } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputSourceLimitWarning.js';
import { getHomepageUpsellsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/upsellKeys.js';
import { getHomepageUpsells } from '#pplx/frontend/apps/ask/queries/upsell-queries/getHomepageUpsells.js';
import { useSourceMeta } from '#pplx/frontend/apps/ask/sources/hooks/useSourceMeta.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
/** Spacing-neutral variant for Composer's host-spaced banner slot. */
export function PremiumSourceLimitWarningBanner({ isFollowUp, }) {
    return _jsx(PremiumSourceLimitWarningContent, { isFollowUp: isFollowUp, hasBottomSpacing: false });
}
export function PremiumSourceLimitWarningContent({ isFollowUp, hasBottomSpacing, }) {
    const sourceLimitWarning = useAskInputSourceLimitWarning({ isFollowUp });
    const hasInputUpsell = useHasInputUpsell(isFollowUp);
    if (hasInputUpsell || !sourceLimitWarning) {
        return null;
    }
    return (_jsx(PremiumSourceLimitWarningInner, { ...sourceLimitWarning, hasBottomSpacing: hasBottomSpacing }));
}
function PremiumSourceLimitWarningInner({ source, upgrade, hasBottomSpacing, }) {
    const { $t } = useIntl();
    const { label } = useSourceMeta({ sourceId: source });
    const title = useMemo(() => $t({
        defaultMessage: 'You have one {label} query remaining this month.',
        description: 'Warning message shown above the ask input when the user has one premium source query left',
        id: '6ef422a224',
    }, { label }), [$t, label]);
    const buttonText = useMemo(() => upgrade &&
        $t({
            defaultMessage: 'Upgrade',
            description: 'Button label to upgrade plan in the premium source limit warning',
            id: '220b044b9b',
        }), [$t, upgrade]);
    const Container = upgrade ? 'button' : 'div';
    return (_jsx(Motion.Expand, { isVisible: true, children: _jsx("div", { className: classNames('flex justify-center', { 'pb-4': hasBottomSpacing }), children: _jsxs(Container, { className: classNames('flex max-w-full items-center gap-6 rounded-xl bg-subtle py-1.5 pl-2.5', upgrade ? 'pr-1.5' : 'pr-2.5'), onClick: upgrade, children: [_jsxs("div", { className: "flex min-w-0 items-center gap-2 text-secondary", children: [_jsx(Icon, { icon: $icon('bolt'), size: "small" }), _jsx(TextPrimitive, { variant: "small", truncate: true, children: title })] }), buttonText && (_jsx("div", { className: "flex h-8 shrink-0 items-center justify-center rounded-lg bg-super-subtle px-2.5 transition-colors hover:bg-super-soft", children: _jsx(TextPrimitive, { variant: "smallBold", color: "super", children: buttonText }) }))] }) }) }));
}
function useHasInputUpsell(isFollowUp) {
    const { data } = useQuery({
        enabled: isFollowUp,
        queryKey: getHomepageUpsellsQueryKey(),
        queryFn: () => getHomepageUpsells(''),
        // Cache for the duration of the session (no staleTime means it won't refetch until page refresh)
        staleTime: Infinity,
        gcTime: Infinity,
    });
    return Boolean(isFollowUp && data?.input_upsell_information);
}
//# sourceMappingURL=PremiumSourceLimitWarning.js.map